module.exports = __webpack_public_path__ + "static/media/1.ae8c84e7.mp3";